module.exports = __webpack_public_path__ + "assets/img/14_896_big.2d465c80.jpg";